module.exports = __webpack_public_path__ + "static/granathakids-b059500e34ac0fbbd75af5c00beef08b.png";